import { useState } from 'react'
import { useRouter } from 'next/router'
import { captureException } from '@sentry/nextjs'

import accountAnalytics from '~/analytics/account/accountAnalytics'

import { setAuthType } from '~/auth/slices/recaptcha.slice'
import { useAppDispatch } from '~/redux/hooks'

import { ButtonClickTypes } from '~/analytics/account/accountEvents.types'

import { AuthTypes } from '../types/auth.types'

import useGetFacebookRedirectURI from './useGetFacebookAuthRedirectUri'

const useAuthenticateWithFacebook = (
  redirectBack?: boolean,
): {
  loading: boolean
  handleLoginWithFacebook: () => void
} => {
  const router = useRouter()
  const [loading, setLoading] = useState<boolean>(false)

  const facebookLoginUri = useGetFacebookRedirectURI(redirectBack)
  const dispatch = useAppDispatch()

  const handleLoginWithFacebook = (): void => {
    try {
      dispatch(setAuthType(AuthTypes.FACEBOOK))
      accountAnalytics.logButtonClick(ButtonClickTypes.AUTH_FACEBOOK)
      router.replace(facebookLoginUri)
      setLoading(true)
    } catch (error) {
      setLoading(false)
      captureException(error, { tags: { feature: 'auth', action: 'facebook-login' } })
    }
  }

  return {
    loading,
    handleLoginWithFacebook,
  }
}

export default useAuthenticateWithFacebook
